var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.636822mm",
    height: "45.88195mm",
    viewBox: "0 0 48.636822 45.88195",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-56.171248,-89.337699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.600001,
      paintOrder: "stroke fill markers"
    },
    d: "m 75.599003,89.337699 -4.95887,1.105359 3.161564,9.006686 2.767273,-0.672827 z m 11.601359,0.04393 -2.026233,9.328113 2.709396,0.876432 4.119128,-8.547798 z m -26.390637,9.71982 -3.001367,4.098461 8.312671,4.69222 1.638143,-2.32957 z m 41.503405,0.182935 -7.704435,5.636356 1.446424,2.45308 8.752951,-3.66386 z m -18.368383,2.597766 -11.383801,1.57458 -5.074626,11.17607 6.029089,6.41924 2.686658,7.15202 12.758911,-1.84175 -0.500744,-8.02896 4.233333,-8.84494 z m -2.858224,3.27474 0.728121,15.71997 -2.01073,0.18036 -3.861779,-14.04307 z m 13.10566,9.04751 -0.490409,2.80551 9.038726,2.8882 0.971,-4.98678 z m -28.711942,2.43499 -9.308993,1.83917 1.559595,4.83484 8.67544,-3.98115 z m 16.997412,6.01772 0.596863,2.01383 -2.881995,0.63511 -0.198437,-2.25465 z m 7.531323,5.01727 -13.823445,2.03502 0.500227,2.2965 13.754716,-2.39986 z m 0.734839,2.78174 -13.702523,2.48047 0.304375,1.99574 5.895247,-0.87126 1.052132,1.15858 1.242818,-0.36121 0.157613,-1.24747 5.352645,-1.1958 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/Hint.431347d8a04cf69f9dadf09ee5e3eed8.svg";
export { ForwardRef as ReactComponent };